import Service from "./service";

export default class SynchronizationsService extends Service {
  static MAX_NUMBER_BY_PAGE = 30;

  private static list = async (params) => {
    try {
      const token = Service.token();
      let dateString = "";
      let searchString = "";
      const page = params.page ? params.page : 1;
      const limitAndPageString = `limit=${
        params.limit ? params.limit : SynchronizationsService.MAX_NUMBER_BY_PAGE
      }&page=${page}`;

      if (params.payload.searchByUserData) {
        searchString = `&searchByUserData=${encodeURIComponent(
          params.payload.searchByUserData
        )}`;
      }

      if (
        params.payload.hasOwnProperty("beginDate") &&
        params.payload.hasOwnProperty("endDate")
      )
        dateString = `&beginDate=${params.payload.beginDate}&endDate=${params.payload.endDate}`;

      const res = await fetch(
        `${Service.getAPIData()}/admin/sincronizacoes?${limitAndPageString}${dateString}${searchString}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) return Promise.resolve(res.json());
      else return Promise.reject(res.json());
    } catch (e) {
      return Promise.reject(e);
    }
  };

  private static listUserSyncs = async (params) => {
    try {
      let userId = params.userId;
      const token = Service.token();
      const page = params.page ? params.page : 1;
      const limitAndPageString = `limit=${
        params.limit ? params.limit : SynchronizationsService.MAX_NUMBER_BY_PAGE
      }&page=${page}`;

      let orderAndOrderByString = "";
      if (params.payload.order && params.payload.orderBy)
        orderAndOrderByString = `&order=${params.payload.order}&orderBy=${params.payload.orderBy}`;

      const res = await fetch(
        `${Service.getAPIData()}/admin/sincronizacoes/users/${userId}?${limitAndPageString}${orderAndOrderByString}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) return Promise.resolve(res.json());
      else return Promise.reject(res.json());
    } catch (e) {
      return Promise.reject(e);
    }
  };

  private static listUserProjectSyncs = async (params) => {
    try {
      const syncId = params.payload.syncId;
      const token = Service.token();
      const res = await fetch(
        `${Service.getAPIData()}/admin/sincronizacoes/${syncId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) return Promise.resolve(res.json());
      else return Promise.reject(res.json());
    } catch (e) {
      return Promise.reject(e);
    }
  };

  /* Public Calls */
  static getSynchronizations = async (params) => {
    return await SynchronizationsService.list(params);
  };

  static getUserSynchronizations = async (params) => {
    return await SynchronizationsService.listUserSyncs(params);
  };

  static getUserProjectsSynchs = async (params) => {
    return await SynchronizationsService.listUserProjectSyncs(params);
  };
}
